// user
export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR'
export const SET_USER = 'SET_USER'

// users
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR'
export const SET_USERS = 'SET_USERS'
export const SET_META = 'SET_META'
export const DELETE_USER = 'DELETE_USER'

// update user role
export const UPDATE_USER_ROLE_REQUEST = 'UPDATE_USER_ROLE_REQUEST'
export const UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS'
export const UPDATE_USER_ROLE_ERROR = 'UPDATE_USER_ROLE_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/users/types.js